export class GdsgBigtableClusterStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serveNodes",
            "baseName": "serveNodes",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "cpuLoad",
            "baseName": "cpuLoad",
            "type": "number",
            "format": "double"
        },
        {
            "name": "diskBytesUsed",
            "baseName": "diskBytesUsed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "observedAtMs",
            "baseName": "observedAtMs",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgBigtableClusterStats.attributeTypeMap;
    }
    constructor() {
    }
}
